export default "__VITE_ASSET__BEvO3uxB__"